/* eslint-disable */
import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useShellStore } from '../shellStore';

// Small effects of the Developments bar (CLB-079).

// Publishes the bar's MEASURED height as the shell's filterBarH, so --app-header-height (App.js) follows the
// card + result line (it wraps to a second line of chips when many are chosen). ShellRoot writes 48 for every
// portal bar; this bar re-asserts its own height whenever that happens.
export function useDevsChrome(ref) {
  const h = useRef(0);
  useLayoutEffect(() => {
    const el = ref.current; if (!el) return undefined;
    const set = (v) => { if (useShellStore.getState().filterBarH !== v) useShellStore.getState().setChrome({ filterBarH: v }); };
    const publish = () => { h.current = Math.round(el.getBoundingClientRect().height); set(h.current); };
    publish();
    const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(publish) : null;
    ro && ro.observe(el);
    const unsub = useShellStore.subscribe((s) => { if (h.current && s.filterBarH !== h.current) set(h.current); });
    return () => { ro && ro.disconnect(); unsub(); h.current = 0; useShellStore.getState().setChrome({ filterBarH: 48 }); };
  }, []); // eslint-disable-line
}

// The same designer scoping DevelopmentsTab applies: an admin sees every dev, anyone else only their own
// designer names (profile.designer_names, else the e-mail prefix). The faceted counts honour it.
export function useDevsScope(role, user, myProfile) {
  return useMemo(() => {
    if (role === 'admin') return undefined;
    const mine = myProfile?.designer_names?.length ? myProfile.designer_names.map((n) => String(n).toLowerCase()) : [user?.email?.split('@')[0]?.toLowerCase()].filter(Boolean);
    return (d) => mine.includes((d.designer || '').toLowerCase());
  }, [role, user?.email, myProfile]);
}

export function useOnline() {
  const [on, setOn] = useState(typeof navigator === 'undefined' ? true : navigator.onLine !== false);
  useEffect(() => {
    const a = () => setOn(true), b = () => setOn(false);
    window.addEventListener('online', a); window.addEventListener('offline', b);
    return () => { window.removeEventListener('online', a); window.removeEventListener('offline', b); };
  }, []);
  return on;
}
